export default __webpack_public_path__ + "static/media/966.efd30df7.jpg";